import React from "react";
//react-router-dom imports
import { Switch, Route, Redirect } from "react-router-dom";

//Pages import
import Restaurants from "../../Pages/Restaurants";
import Customers from "../../Pages/Customers";
import NewRequests from "../../Pages/NewRequests";
import RestaurantEdit from "../../Pages/RestaurantEdit";
import CustomerEdit from "../../Pages/CustomerEdit";
import ResetPassword from "../../Pages/ResetPassword";
import Transaction from "../../Pages/Transaction";
import PaymentReport from "../../Pages/PaymentReport";
import LicenseApiKeys from "src/Pages/LicenseApiKeys";
import PosData from '../../Pages/PosData'
import ResendPass from "src/Pages/ResendPass";
import VersionControl from "src/Pages/VersionControl";

import SMSReport from '../../Pages/SMSReport';
const Routes = () => {
  return (
    <div>
      <Switch>
        <Route exact path="/" render={(props) => <Restaurants {...props} />} />
        <Route exact path="/restaurants/:id" render={(props) => <RestaurantEdit {...props} />} />
        <Route exact path="/customers" render={(props) => <Customers {...props} />} />
        <Route exact path="/customers/:id" render={(props) => <CustomerEdit {...props} />} />
        <Route exact path="/new-requests" render={(props) => <NewRequests {...props} />} />
        <Route exact path="/transaction" render={(props) => <Transaction {...props} />} />
        <Route exact path="/version" render={(props) => <VersionControl {...props} />} />
        <Route exact path="/license-apikeys" render={(props) => <LicenseApiKeys {...props} />} />
        <Route exact path="/reset-password" render={(props) => <ResetPassword {...props} />} />
        <Route exact path="/gateway" render={(props) => <PaymentReport {...props} />} />
        <Route
          exact
          path="/resend-pass"
          render={(props) => <ResendPass {...props} />}
        />
        <Route exact path="/pos-data" render={(props) => <PosData {...props} />} />
        <Route exact path="/sms-report" render={(props) => <SMSReport />} />
        <Redirect from="*" to="/" />
      </Switch>
    </div>
  );
};

export default Routes;
